import React from "react";
import { Subtitle } from "./Subtitle";

export interface PageNumberProps {
  PageNumber: number;
  PageTotal: number;
}

export function PageNumber(props: PageNumberProps) {
  return (
    <span className="applicationStepProgressText">
      (Step {props.PageNumber} of {props.PageTotal})
    </span>
  );
}

export function PageNumberSubtitle(props: PageNumberProps) {
  return (
    <Subtitle>
      <span className="applicationStepProgressText">
        (Step {props.PageNumber} of {props.PageTotal})
      </span>
    </Subtitle>
  );
}
